export class rowOrder {
    public nameInThead: String;
    public position: number;
    public nameInObject: String;
    public nameInObjectArray: String;
    public filterBy: boolean;
    public orderBy: boolean;
    public size: number;
    public sizeH: any;
    public textAlign: String;
    public horizontalAlign: String;
    public flexDirection: String;
    public typeSize: String;
    public borderRadius: String;
    public actionRow: boolean;
    public padding: String;
    public buttonHeightPercent: number;
    public viewIcon: boolean;
    public activeIcon: boolean;
    public activeIconArray: boolean;
    public activeIconArrayName: String;
    public dataStatusActive: any;
    public activeResultInObject: any;
    public inactiveResultInObject: any;    
    public searchFunction: boolean;
    public arrayContent: boolean;
}